import React, { useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Select.css';
import Card from '../Card/Card';
import { SelectSnippet } from '../../snippets/SelectSnippet/SelectSnippet';
import { Copy } from 'lucide-react';
const Select = () => {
  const snippetContainerRef = useRef(null);
  const [showScanning, setShowScanning] = useState(false);

  const copySnippet = () => {
    if (snippetContainerRef.current) {
      const range = document.createRange();
      range.selectNode(snippetContainerRef.current);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      window.getSelection().removeAllRanges();

      setShowScanning(true);
      setTimeout(() => setShowScanning(false), 1000);
    }
  };
  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      <div className="input-field select-field">
        <select name="country" id="countryList">
          <option value="india">Japan</option>
          <option value="brazil">england</option>
          <option value="german">maxico</option>
        </select>
        <span className='drop-down'>&#9013;</span>
      </div>
      <div className="input-field select-field mandate">
        <label htmlFor="countryList2">Select the value</label>
        <select name="country" id="countryList2">
          <option value="india">Japan</option>
          <option value="brazil">england</option>
          <option value="german">maxico</option>
        </select>
        <span className='drop-down'>&#9013;</span>
      </div>
      <div className={`center-container ${showScanning ? 'scanning' : ''}`}>

        <div className='snippet' ref={snippetContainerRef}>
          <SelectSnippet />
          <button aria-label="Copy Button" onClick={copySnippet}>
            <Copy />
          </button>

        </div>
      </div>
    </motion.div>
  );
}

const SelectCard = () => {
  return (
    <Card CardTitle="Select"
      CardBody={<Select />}
    />
  );
}

export default SelectCard;